<template>
  <section style="padding-top: 0px!important;">
    <div class="d-flex" style="justify-content: flex-end;">
      <input type="file" id="uploadFile" @change="uploadFile" style="display: none;" ref="file">
      <a style="text-decoration: none" @click="test">
        <v-icon>mdi-paperclip-plus</v-icon>
        {{ $t('attachFile') }}
      </a>
    </div>
    <v-list class="d-flex" style="justify-content: flex-end;" color="transparent" dense>
      <v-list-item class="pr-0 mr-0" v-for="(attachment, i) in attachments" :key="i">
        <v-list-item-icon class="mt-3 mr-2">
          <TcnFileIcon :file-name="attachment.name"/>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title v-text="attachment.name"></v-list-item-title>
        </v-list-item-content>
        <v-list-item-action>
          <v-icon @click="attachmentDelete(attachment)">mdi-delete</v-icon>
        </v-list-item-action>

      </v-list-item>
    </v-list>


  </section>
</template>

<script>
import TcnFileIcon from "../TecnaFileIcon/TcnFileIcon.vue"

export default {
  name: "AttachmentList",
  props: {
    attachments: {
      type: Array,
      default: []
    },
  },
  components: {TcnFileIcon},
  methods: {
    uploadFile() {
      this.attachments.push(this.$refs.file.files[0]);
    },
    attachmentDelete(attachment) {
      const index = this.attachments.indexOf(attachment)
      this.attachments.splice(index, 1)
    },
    getAttachmentMediaType(name) {
      return name != null ? name.split(".").pop().toLowerCase() : "blank"
    },
    test() {
      document.getElementById('uploadFile').click();
    }
  }
}
</script>

<style scoped>

</style>

<i18n lang="i18n">
{
  "en": {
    "attachFile": "Add file"
  },
  "pl": {
    "attachFile": "Załącz plik"
  }
}
</i18n>
